import { TEDFormatDate } from '../../../Utils/Formatters/FormatterClasses/TEDFormatDate';
import { ParseResult } from '../../../Utils/Formatters/FormatterTypes';

export const getTryParseDate =
  (formatter: TEDFormatDate, parseParams?: string) => (text: string | null) => {
    const res = formatter.parser.parse(text || '', parseParams);
    if (res.result === ParseResult.OK) {
      return formatter.displayer.display(res.value, true);
    } else {
      return undefined;
    }
  };
